import React from 'react'

import { Typography } from '~/components/elements/Typography'

export type UserCellProps = {
  dataItem: {
    userSeat: { total: number; used: number }
  }
}

export const UserCell = ({ dataItem }: UserCellProps) => {
  const { userSeat } = dataItem

  return (
    <td>
      <Typography fontSize={14} variant="normal">
        {`${userSeat.used} / ${userSeat.total}`}
      </Typography>
    </td>
  )
}
